<template>
  <v-menu
    open-on-hover
    open-on-click
    location="bottom start"
    origin="bottom end"
    :offset="[8, 64]"
    :close-delay="1000"
  >
    <template #activator="{ props }">
      <v-list-item
        :loading="postFildersFromImanagePending"
        v-bind="props"
        data-locator="imanage-import-menu-button"
      >
        <div class="d-flex align-center justify-space-between w-100">
          <div class="d-flex align-center">
            <v-img src="@/assets/img/iManage_logo.png" class="mr-2" width="18" />
            {{ $t("common.imanage.IManageListItemImport.importFromImanage") }}
          </div>
          <app-icon-ds
            icon="chevron-right"
            weight="far"
            size="xs"
          />
        </div>
      </v-list-item>
    </template>
    <v-list data-locator="imanage-import-menu">
      <v-list-item data-locator="import-files-menu-item" @click="openIManageFilesPicker">
        <v-list-item-title>
            {{ $t("common.imanage.IManageListItemImport.importFilesFromImanage") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item data-locator="import-folders-menu-item" @click="openIManageFoldersPicker">
        <v-list-item-title>
            {{ $t("common.imanage.IManageListItemImport.importFoldersFromImanage") }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <IManageFilePickerDialog
    v-model:is-open="iManageFilesPickerDialogIsOpen"
    @files="onImanageFiles"
  />
  <IManageFolderPickerDialog 
    v-if="iManageFoldersPickerDialogIsOpen"
    v-model:is-open="iManageFoldersPickerDialogIsOpen"
    @folders="onImanageFolders"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapActions, mapState } from "vuex"

import { GET_PAGINATED_DOCUMENTS, POST_FILDERS_FROM_IMANAGE } from "@/store/modules/documents/action_types"

import IManageFilePickerDialog from "./IManageFilePickerDialog.vue"
import IManageFolderPickerDialog from "./IManageFolderPickerDialog.vue"
import { type IManageResult, type PostImanageData } from "./types"
import { toast } from "../utils/toast"

export default defineComponent({
  name: "IManageListItemImport",
  components: {
    IManageFilePickerDialog,
    IManageFolderPickerDialog,
  },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      iManageFilesPickerDialogIsOpen: false,
      iManageFoldersPickerDialogIsOpen: false,
    }
  },
  computed: {
    ...mapState('documents', ['postFildersFromImanagePending', 'paginatedDocumentsCurrentFolderId']),
  },
  methods: {
    ...mapActions('documents', [POST_FILDERS_FROM_IMANAGE, GET_PAGINATED_DOCUMENTS]),
    openIManageFilesPicker () {
      this.iManageFilesPickerDialogIsOpen = true
    },
    openIManageFoldersPicker () {
      this.iManageFoldersPickerDialogIsOpen = true
    },
    onImanageImport(type: 'files' | 'folders', result: IManageResult) {
      const data: PostImanageData = {
        parentId: this.paginatedDocumentsCurrentFolderId,
        [type]: result.selected.split(','),
      }
      this.preparePostFildersFromIManage(data)
    },
    onImanageFiles(files: IManageResult) {
      this.onImanageImport('files', files)
    },

    onImanageFolders(folders: IManageResult) {
      this.onImanageImport('folders', folders)
    },
    async preparePostFildersFromIManage (data: PostImanageData) {
      try {
        await this.POST_FILDERS_FROM_IMANAGE({
          mnemo: this.mnemo,
          data,
        })
        toast.success(this.$t('common.imanage.IManageListItemImport.postFildersFromIManageSuccess'))
        this.GET_PAGINATED_DOCUMENTS()
      } catch (error) {
        toast.error(this.$t('common.imanage.IManageListItemImport.postFildersFromIManageError'))
      }
    },
  },
})
</script>